import { uiFormat, uiText } from '../../i18n';
import type { StudioForm } from './studio-api';
import { studioMediaUrl } from './studio-preview-model';
import { record, text } from './studio-content';
import type { StudioUploadExampleData } from './StudioUploadExample';
const EXT: Record<string, string> = {
  'image/jpeg': 'JPG',
  'image/png': 'PNG',
  'image/webp': 'WebP',
  'video/mp4': 'MP4',
  'video/quicktime': 'MOV',
  'video/webm': 'WebM',
  'audio/mpeg': 'MP3',
  'audio/wav': 'WAV',
  'audio/x-wav': 'WAV',
  'audio/mp4': 'M4A',
  'audio/x-m4a': 'M4A',
};


export function uploadExample(value: unknown): StudioUploadExampleData | null {
  const raw = record(value);
  const before = studioMediaUrl(raw.before_url ?? raw.before);
  const after = studioMediaUrl(raw.after_url ?? raw.after);
  if (!before || !after) return null;
  const labels = Array.isArray(raw.labels) && raw.labels.length === 2 && raw.labels.every(item => typeof item === 'string') ? (raw.labels as [string, string]) : undefined;
  return { before, after, title: text(raw.title) || undefined, text: text(raw.text) || undefined, labels };
}
/** Ограничения рамки одной строкой: «JPG или PNG, до 10 МБ». */
export function uploadLimits(field: StudioForm['fields'][number]): string {
  const names = [...new Set((field.upload?.accept ?? []).map(mime => EXT[mime] ?? mime.split('/')[1]?.toUpperCase()).filter(Boolean))];
  const list = names.length > 1 ? `${names.slice(0, -1).join(', ')} ${uiText('или')} ${names.at(-1)}` : (names[0] ?? '');
  const bytes = field.upload?.max_bytes;
  const size = bytes ? uiFormat('до {0} МБ', Math.round(bytes / 1024 / 1024)) : '';
  return [list, size].filter(Boolean).join(', ');
}
